// eslint-disable-next-line import/no-unresolved
import Cookies from 'https://cdn.skypack.dev/js-cookie'

Shopify.Products = (function () {
  let config = {
    maxToShow: 8,
    minToShow: 4,
    howManyToStoreInMemory: 10,
    gallerySection: '.sec-FeaturedProducts-recentlyViewed',
    galleryContainer: '[data-gallery-recently]',
    onComplete: null,
    onEmpty: null,
  }

  let productHandleQueue = []

  const setInnerHTML = function (elm, html) {
    elm.innerHTML = html
    Array.from(elm.querySelectorAll('script')).forEach(oldScript => {
      const newScript = document.createElement('script')
      Array.from(oldScript.attributes).forEach(attr =>
        newScript.setAttribute(attr.name, attr.value)
      )
      newScript.appendChild(document.createTextNode(oldScript.innerHTML))
      oldScript.parentNode.replaceChild(newScript, oldScript)
    })
  }

  const cookie = {
    configuration: {
      expires: 90,
      path: '',
    },
    name: 'shopify_recently_viewed',
    write (recentlyViewed) {
      Cookies.set(this.name, recentlyViewed.join(','), this.configuration)
    },
    read () {
      let recentlyViewed = []
      const cookieValue = Cookies.get(this.name)
      if (cookieValue) {
        recentlyViewed = cookieValue.split(',')
      }
      return recentlyViewed
    },
    destroy () {
      Cookies.remove(this.name)
    },
    remove (productHandle) {
      const recentlyViewed = this.read()
      const position = recentlyViewed.indexOf(productHandle)
      if (position !== -1) {
        recentlyViewed.splice(position, 1)
        this.write(recentlyViewed)
      }
    },
  }

  const finalize = function () {
    const gallerySection = document.querySelector(config.gallerySection)
    const galleryContainer = document.querySelector(config.galleryContainer)
    if (!!gallerySection && galleryContainer.children.length !== 0) {
      gallerySection.classList.remove('hidden')
    }
    // If we have a callback.
    if (config.onComplete) {
      try {
        config.onComplete()
      } catch (error) {}
    }
  }

  const getRecentProducts = async function () {
    const productHandle = window.location.pathname.match(
      // eslint-disable-next-line no-useless-escape
      /\/products\/([a-z0-9\-]+)/
    )[1]
    productHandleQueue = productHandleQueue.filter(handle => {
      return productHandle !== handle
    })
    if (productHandleQueue.length < config.minToShow) {
      if (config.onEmpty) {
        try {
          config.onEmpty()
        } catch (error) {}
      }
      return
    }
    productHandleQueue.length = config.maxToShow
    const searchRecentlyUrl = `/search?view=recently&q=${productHandleQueue.toString()}`

    await fetch(searchRecentlyUrl)
      .then(response => {
        return response.text()
      })
      .then(html => {
        setInnerHTML(document.querySelector(config.galleryContainer), html)
      })
      .catch(err => {
        console.warn('Something went wrong.', err)
      })

    finalize()
  }

  return {
    showRecentlyViewed (params) {
      params = params || {}
      // Update defaults.
      config = { ...config, ...params }

      // Read cookie.
      productHandleQueue = cookie.read()

      if (productHandleQueue === null || productHandleQueue === undefined) {
        return false
      }

      config.maxToShow = Math.min(productHandleQueue.length, config.maxToShow)

      if (config.maxToShow) {
        getRecentProducts()
      } else {
        // Hide
      }
    },

    getConfig () {
      return config
    },

    clearList () {
      cookie.destroy()
    },

    recordRecentlyViewed (params) {
      params = params || {}
      let recentlyViewed = cookie.read()
      let productHandle
      let position

      // Update defaults.
      config = { ...config, ...params }

      // If we are on a product page.
      if (window.location.pathname.indexOf('/products/') !== -1) {
        // What is the product handle on this page.
        productHandle = window.location.pathname.match(
          // eslint-disable-next-line no-useless-escape
          /\/products\/([a-z0-9\-]+)/
        )[1]
        // In what position is that product in memory.
        position = recentlyViewed.indexOf(productHandle)
        // If not in memory.
        if (position === -1) {
          // Add product at the start of the list.
          recentlyViewed.unshift(productHandle)
          // Only keep what we need.
          recentlyViewed = recentlyViewed.splice(
            0,
            config.howManyToStoreInMemory
          )
        } else {
          // Remove the product and place it at start of list.
          recentlyViewed.splice(position, 1)
          recentlyViewed.unshift(productHandle)
        }

        // Update cookie.
        cookie.write(recentlyViewed)
      }
    },
  }
})()
